import { createUser } from 'common/api/v1/users';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import { fetchData as fetchUserSettings } from '../../profile/actions';
import { SAVE_ITEM_SUCCESS, SAVE_ITEM_FAILURE } from '../actionTypes';
import { companyUsersActions } from '../reducer';

import filterUsers from './filterUsers';
import resetForm from './resetForm';
import toggleModalProduct from './toggleModalProduct';

export default (filterData, values) => (dispatch) => {
    createUser(values)
        .then((response) => {
            dispatch(companyUsersActions[SAVE_ITEM_SUCCESS](response.data));

            dispatch(filterUsers(filterData));
            dispatch(fetchUserSettings());
            dispatch(toggleModalProduct(false));
            dispatch(resetForm());
            showToast();
        })
        .catch((error) => {
            dispatch(
                companyUsersActions[SAVE_ITEM_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
